<template>
    <div class="filter-steps--container">
        <md-field class="datepicker-container">
            <md-datepicker
                data-testid="service-areas-dashboard-date"
                class="filter-steps--choices filter-step-date"
                v-model="selectedDateFilterValue"
                md-immediately
                :md-debounce="100"
                ref="mdDatePicker"
                :clearable="false"
            ></md-datepicker>
        </md-field>
    </div>
</template>
<script>
import moment from 'moment';
import _ from 'lodash';

export default {
    name: 'ServiceAreasDashboardFilterComponent',
    props: {
        selectedDate: {
            type: String, // Date "2021-07-30"
            default: ''
        }
    },
    data() {
        return {
            selectedDateFilterValue: ''
        };
    },
    watch: {
        selectedDateFilterValue(newValue, oldValue) {
            this.handleFilter();
        }
    },
    methods: {
        // eslint-disable-next-line func-names
        handleFilter: _.debounce(function() {
            this.handleFilteredValue();
        }, 700),
        clearFilters() {
            this.selectedDateFilterValue = '';
        },
        handleFilteredValue() {
            // use nextTick to ensure that selectedDate value has already been changed.
            // this is because the @selected method of md-datepicker is asynchronous.
            this.$nextTick(() => {
                const { selectedDateFilterValue } = this;
                let selectedDate = '';
                if (selectedDateFilterValue) {
                    selectedDate = moment(selectedDateFilterValue).format('YYYY-MM-DD');
                }

                this.$emit('onFilterDashboard', {
                    selectedDate
                });
            });
        }
    },
    mounted() {
        if (!this.$root.isDesktop && this.$refs.mdDatePicker) {
            this.$refs.mdDatePicker.$refs.input.$el.setAttribute('readonly', true);
        }

        this.selectedDateFilterValue = this.selectedDate;
    }
};
</script>

<style lang="scss" scoped>
.filter-steps--container {
    flex-grow: 2;
    ::v-deep .md-field {
        min-height: 48px;
        margin-right: 20px;
        margin-top: 0;
        vertical-align: top;
    }

    ::v-deep > .md-field {
        display: inline-block;
        width: 180px;
    }

    .filter-step-date {
        margin-right: 0;
        min-height: initial;
        position: absolute;
        z-index: 1;
        width: 140px;
        ::v-deep .md-clear {
            display: none;
        }
        ::v-deep .md-input {
            width: 100%;
        }
    }

    ::v-deep .md-datepicker:after,
    ::v-deep .md-datepicker:before {
        bottom: 0;
        height: 0;
    }

    ::v-deep .md-datepicker:before,
    ::v-deep .md-datepicker:after {
        bottom: 30px;
        content: 'Date';
        color: #aaaaaa;
        font-weight: 400;
        font-size: 14px;
        transform: none;
        z-index: 1;
    }

    ::v-deep .md-has-value:before,
    ::v-deep .md-has-value:after {
        bottom: 0;
        height: 0;
        content: '';
    }

    ::v-deep .md-datepicker .md-input-action {
        z-index: 99;
        right: 52px;
    }
}

.datepicker-noevent {
    ::v-deep .md-datepicker {
        input {
            pointer-events: none;
        }
    }
}
</style>
